module.exports = __webpack_public_path__ + "static/media/arrow-up.4a7fd1a3.svg";